import { VNode } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Auth } from 'aws-amplify';

@Component
export default class Layout extends Vue {
  @Prop(String)
  name!: string;

  async created() {
    const name = await this.getLayout();
    this.$parent.$emit('update:layout', name);
  }

  render(): VNode {
    // @ts-ignore
    return this.$slots.default[0];
  }

  async getLayout(): Promise<string> {
    let { name } = this;
    if (name === 'LayoutDefault') {
      try {
        await Auth.currentAuthenticatedUser();
      } catch (e) {
        name = 'LayoutPublic';
      }
    }

    // Check if layout component has already been registered.
    // @ts-ignore
    if (!Vue.options.components[name]) {
      Vue.component(name, () => import(`../layouts/${name}.vue`));
    }
    return name;
  }
}
